"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIMediaObject;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _componentProp = require("../utils/propTypes/componentProp");

var _UIMedia = _interopRequireDefault(require("./UIMedia"));

var _UIMediaBody = _interopRequireDefault(require("./UIMediaBody"));

var _UIMediaLeft = _interopRequireDefault(require("./UIMediaLeft"));

var _UIMediaRight = _interopRequireDefault(require("./UIMediaRight"));

function UIMediaObject(props) {
  var children = props.children,
      itemLeft = props.itemLeft,
      itemRight = props.itemRight,
      MediaBody = props.MediaBody,
      MediaLeft = props.MediaLeft,
      MediaRight = props.MediaRight,
      rest = (0, _objectWithoutProperties2.default)(props, ["children", "itemLeft", "itemRight", "MediaBody", "MediaLeft", "MediaRight"]);
  return _react.default.createElement(_UIMedia.default, rest, itemLeft ? _react.default.createElement(MediaLeft, null, itemLeft) : null, _react.default.createElement(MediaBody, null, children), itemRight ? _react.default.createElement(MediaRight, null, itemRight) : null);
}

UIMediaObject.propTypes = Object.assign({}, _UIMedia.default.propTypes, {
  itemLeft: _propTypes.default.node,
  itemRight: _propTypes.default.node,
  MediaBody: (0, _componentProp.getComponentPropType)(_UIMediaBody.default),
  MediaLeft: (0, _componentProp.getComponentPropType)(_UIMediaLeft.default),
  MediaRight: (0, _componentProp.getComponentPropType)(_UIMediaRight.default)
});
UIMediaObject.defaultProps = Object.assign({}, _UIMedia.default.defaultProps, {
  MediaBody: _UIMediaBody.default,
  MediaLeft: _UIMediaLeft.default,
  MediaRight: _UIMediaRight.default
});
UIMediaObject.displayName = 'UIMediaObject';
module.exports = exports.default;